import React from "react";

import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Company } from "@mapmycustomers/shared/types/entity";

import { SHORT_ADDRESS } from "@app/util/consts";
import { entityToAddressLines } from "@app/util/formatters";

import styles from "./CompanyName.module.scss";

interface Props {
  company: Company;
}

const CompanyNameWithAddress: React.FC<Props> = ({ company }) => {
  const intl = useIntl();

  const { line1, line2 } = entityToAddressLines(company, SHORT_ADDRESS);
  const addressText =
    [line1, line2].filter((text) => !!text).join(", ") ||
    intl.formatMessage({
      id: "company.label.noAddress",
      defaultMessage: "No address",
      description: "No address label",
    });

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faBuilding} />
      </div>
      <div className={styles.details}>
        <div className={styles.name}>{company.name}</div>
        <div className={styles.address}>{addressText}</div>
      </div>
    </div>
  );
};

export default CompanyNameWithAddress;
